import {
    useGetValueNarrativeCategoriesQuery,
    ValueNarrativeCategory,
} from '../queries/valueNarratives/useGetValueNarrativeCategoriesQuery'
import useActivityStatuses from '../hooks/useActivityStatuses'
import { LinkedItems } from '../../components/Linking/Linking.types'

export const LINKING_GROUPING_CONFIGS = {
    valueMessage: {
        useQuery: useGetValueNarrativeCategoriesQuery,
        parseQueryResponse: (response: ReturnType<typeof useGetValueNarrativeCategoriesQuery>) => response.data,
        getGroupData: (linkingItem: LinkedItems['valueMessage'][number], categories: ValueNarrativeCategory[]) => {
            const category = categories.find((c) => c._id === linkingItem.extras.categoryId)
            if (!category) return null

            return {
                id: category._id,
                name: category.name,
                order: category.order,
            }
        },
    },
    activity: {
        useQuery: useActivityStatuses,
        parseQueryResponse: (response: ReturnType<typeof useActivityStatuses>) => response.getActivityStatusDetails,
        getGroupData: (
            linkingItem: LinkedItems['activity'][number],
            getActivityStatusDetails: ReturnType<(typeof LINKING_GROUPING_CONFIGS)['activity']['parseQueryResponse']>
        ) => {
            const activityStatusDetails = getActivityStatusDetails(linkingItem.extras.status)
            if (!activityStatusDetails) return null

            return {
                id: activityStatusDetails.id,
                name: activityStatusDetails.name,
                order: activityStatusDetails.order,
                icon: activityStatusDetails.icon,
            }
        },
    },
} as const
